import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  setPermissionsAsync,
  setCompanyConfigAsync,
} from '@/store/slices/AuthSlice';
import {
  setThemeSettings,
  updateUserDataAsync,
} from '@/store/slices/UserSlice';
import { setUserPreferencesAsync } from '@/store/slices/UserPreferencesSlice';
import useRuntimeConfig from '@/hooks/useRuntimeConfig';
import PageSkeleton from './PageSkeleton/PageSkeleton';

export default function SettingsReactLoader({ setEnabledToken }) {
  const dispatch = useDispatch();
  const { config, loading } = useRuntimeConfig();
  const UNIVEN = 'univen';

  const fetchData = async () => {
    try {
      await Promise.all([
        dispatch(setUserPreferencesAsync()).unwrap(),
        dispatch(setCompanyConfigAsync()).unwrap(),
        dispatch(setPermissionsAsync()).unwrap(),
        dispatch(updateUserDataAsync()).unwrap(),
      ]);

      setEnabledToken(true);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    if (loading) return;
    if (typeof window === 'object' && document !== undefined) {
      let tokkoBrokerHostFinal = config?.config?.TOKKO_HOST;
      let theme = 'tokkobroker';

      const isUniven =
        document.referrer.includes(UNIVEN) ||
        window.location.href.includes(UNIVEN);

      if (isUniven) {
        tokkoBrokerHostFinal = config?.themes?.univen?.TOKKO_HOST;
        theme = UNIVEN;
      }

      dispatch(setThemeSettings({ theme }));

      localStorage.setItem('tokkoBrokerHost', tokkoBrokerHostFinal);

      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      const jwtBearer = url.searchParams.get('jwt');

      if (jwtBearer) {
        localStorage.setItem('jwt', jwtBearer);
        params.delete('jwt');
        url.search = params.toString();

        setTimeout(() => {
          window.history.replaceState(null, null, url.toString());
        }, 100);
      }
      fetchData();

      document.documentElement.setAttribute('data-theme', theme);
    }
  }, [loading, config]);

  return <PageSkeleton />;
}
